import { useQuery } from "@tanstack/react-query";
import { getTargetareTermeneStats } from "@/api/endpoints/targetareDate";
import { queryKeys } from "@/lib/queryClient";

export function useGetTargetareTermeneStats() {
  return useQuery({
    queryKey: queryKeys.targetare.termeneStats(),
    queryFn: getTargetareTermeneStats,
    select: (response) => response.data,
    staleTime: 1000 * 30,
    retry: 1,
  });
}
